import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { User } from 'src/app/models/user';
import { FormControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { OnlyLNumbersValidator } from 'src/app/directives/only-numbers-validator.directive';
import { ClipboardService } from 'src/app/services/clipboard.service';
import { SettingsService } from '../../settings.service';
import { SettingsBreadCrumbService, BreadCrumbOptions } from '../../settings-breadcrumb.service';
import { IdentityWhitelabelApiClient } from 'src/app/services/api-clients/identity-whitelabel.api-client';
import { IdsForSettingsService, SystemInfoModel, WhiteLabelInfoModel } from '../../ids-for-settings.service';
import { System } from 'src/app/models/system';
import { IdentitySystemApiClient } from 'src/app/services/api-clients/identity-system.api-client';

@Component({
  templateUrl: './settings-system-overview.page.html'
})
export class SettingsSystemOverviewPage implements OnDestroy {

  selectedSystemId: string = "";
  system!: System;
  user!: User;
  progressSubscription!: number;
  subdate: Date = new Date(Date.now());

  systemIdSubscription: Subscription;

  constructor(
    private translateService: TranslateService,
    private systemApiClient: IdentitySystemApiClient,
    private formBuilder: UntypedFormBuilder,
    private clipboardService: ClipboardService,
    private idsForSettingsService: IdsForSettingsService,
    private settingsService: SettingsService,
    private settingsBreadCrumbService: SettingsBreadCrumbService) {

    // get data
    this.user = this.settingsService.user;
    this.systemIdSubscription = this.idsForSettingsService.selectedSystemId$.subscribe(systemId => {
      if (systemId === this.selectedSystemId) return;
      this.selectedSystemId = systemId;

      // setup specialised breadcrumb
      this.settingsBreadCrumbService.SetSystemCrumbs(BreadCrumbOptions.System_Overview);

      if (systemId) {
        this.systemApiClient.getSystem(systemId).subscribe(systemData => {
          this.system = systemData;
          this.idsForSettingsService.setSelectedSystem(new SystemInfoModel(this.system.system.guid, this.system.system.name));
        });
      }
    });
  }
  
  ngOnDestroy(): void {
    this.systemIdSubscription.unsubscribe();
  }
}
